function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import axios from 'axios';
import axiosMiddleware, { getActionTypes } from 'redux-axios-middleware';
import { requestRejected, unexpectedError } from './actions';

function makeClient() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return axios.create(_objectSpread({
    baseURL: '',
    responseType: 'json',
    headers: {
      Accept: ['application/vnd.api+json', 'application/json'],
      'Content-Type': 'application/json'
    }
  }, options));
}

;
var suffixes = {
  successSuffix: '_RESOLVED',
  errorSuffix: '_REJECTED'
};

var middlewareOptions = _objectSpread({}, suffixes, {
  getClientName: function getClientName(action) {
    return action.meta.apiRequest.client;
  },
  getRequestConfig: function getRequestConfig(action) {
    return action.meta.apiRequest.config;
  },
  getRequestOptions: function getRequestOptions(action) {
    return action.meta.apiRequest.options;
  },
  isAxiosRequest: function isAxiosRequest(action) {
    return action.meta && action.meta.apiRequest;
  },
  returnRejectedPromiseOnError: true
});

var clientOptions = function clientOptions(getAuthToken) {
  return {
    interceptors: {
      request: [function (_ref, req) {
        var getState = _ref.getState,
            getSourceAction = _ref.getSourceAction;
        var reduxAction = getSourceAction(req);
        var apiRequestMeta = reduxAction.meta.apiRequest;
        var authToken = typeof getAuthToken === 'function' ? getAuthToken() : null;

        if (authToken && apiRequestMeta.skipAuthHeader !== true) {
          req.headers['Authorization'] = "Bearer ".concat(authToken);
        }

        if (apiRequestMeta.minimumDuration) {
          // UX can be improved by adding a minimum duration to some requests.
          // For example displaying a spinner for 20ms can be very jarring,
          // whilst ensuring that it will be displayed for a minimum of 500ms,
          // say, can make the transition appear much smoother.
          //
          // `minimumDurationPromise` is used in a response intercepter to
          // delay the dispatch of the redux action.
          apiRequestMeta.minimumDurationPromise = new Promise(function (resolve) {
            return setTimeout(resolve, apiRequestMeta.minimumDuration);
          });
        }

        return req;
      }],
      response: [function (_ref2, req) {
        var getState = _ref2.getState,
            dispatch = _ref2.dispatch,
            getSourceAction = _ref2.getSourceAction;
        var reduxAction = getSourceAction(req.config);
        var apiRequestMeta = reduxAction.meta.apiRequest;

        if (apiRequestMeta.minimumDurationPromise) {
          return Promise.all([req, apiRequestMeta.minimumDurationPromise]).then(function (r) {
            return r[0];
          });
        }

        return req;
      }, {
        error: function error(_ref3, _error) {
          var dispatch = _ref3.dispatch,
              getState = _ref3.getState,
              getSourceAction = _ref3.getSourceAction;
          var response = _error.response;

          try {
            var action = getSourceAction(_error.config);
            dispatch(requestRejected(action, _error, response));
          } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('Error while running error interceptor:', e);
            dispatch(unexpectedError(_error, e));
          }

          return Promise.reject(_error);
        }
      }]
    }
  };
};

export default createMiddleware();
export function createMiddleware() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      axiosClientConfig = _ref4.axiosClientConfig,
      getAuthToken = _ref4.getAuthToken;

  return axiosMiddleware(makeClient(axiosClientConfig), middlewareOptions, clientOptions(getAuthToken));
}
export function resolved(actionType) {
  return getActionTypes({
    type: actionType
  }, suffixes)[1];
}
export function rejected(actionType) {
  return getActionTypes({
    type: actionType
  }, suffixes)[2];
}